// extracted by mini-css-extract-plugin
export default {"sectionHeader":"cCWp91","templatesGrid":"OFg2SO"};